<template>
  <div class="col-md-2 sidebar-profile" v-if="user">
    <div class="my-panel" v-if="features.garden">
      <div class="heading">Thiết lập</div>

      <div class="p-body">
        <router-link
          v-bind:class="{ active: url == '/update-profile' }"
          :to="{ name: 'UpdateProfile' }"
          >{{ "Update" | translate }}</router-link
        >

        <router-link
          :to="{ name: 'Profile', params: { profileId: user.unique_code } }"
          >{{ "View your profile" | translate }}</router-link
        >
        <router-link
          v-if="user.role == role.system_user"
          v-bind:class="{ active: url == '/sub-users' }"
          :to="{ name: 'ManageSubUser' }"
          >{{ "Sub Users" | translate }}</router-link>
        <router-link

          v-bind:class="{ active: url == '/mystore' }"
          :to="{ name: 'ManageStore' }"
          >{{ "My store" | translate }}</router-link>

        <router-link
          v-if="user && user.can_manage_transport_vehicle"
          v-bind:class="{ active: url == '/quan-ly-xe-hang' }"
          :to="{ name: 'ManageTransportVehicle' }"
          >{{ "Manage transport vehicles" | translate }}</router-link>

      </div>
    </div>

    <div class="my-panel" v-if="features.garden">
      <div class="heading">Nhà vườn</div>

      <div class="p-body">
        <a v-bind:class="{ 'disabled': registering_farmer }"  v-if="!user.farmer_id" v-on:click="registerFarmer()"
          >{{ "Register" | translate }}</a
        >
        <!-- <a v-if="user.farmer_id" v-on:click="showModal(user.farmer)"
          >- {{ "Update" | translate }}</a
        > -->
        <router-link
          v-if="user.farmer_id"
          v-bind:class="{ active: url == '/mygarden' }"
          :to="{ name: 'ManageGarden' }"
          >{{ "My gardens" | translate }}</router-link
        >

        <router-link
          v-if="user.farmer_id && !user.group_id"
          v-bind:class="{ active: url == '/my-groups' }"
          :to="{ name: 'ManageGroup' }"
          >{{ "My groups" | translate }}</router-link
        >

        <router-link
          v-if="features.tracking && user.farmer_id"
          :to="{ name: 'ManageTracking', params: {} }"
          >{{ "Manage tracking" | translate }}</router-link
        >
      </div>
    </div>
    <!-- <div class="my-panel" v-if="features.store">
      <div class="heading">Nhà bán lẻ</div>
      <div class="p-body">

      </div>
    </div> -->
    <!-- <form-farmer
      v-if="show_key_form=='formFarmer'"
      ref="formFarmer"
      :pass_data="pass_data"
      @modalData="modalData"
    ></form-farmer> -->
    <form-retailer
      v-if="show_key_form == 'formRetailer'"
      ref="formRetailer"
      :pass_data="pass_data"
      @modalData="modalData"
    ></form-retailer>
  </div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import Config from '@/helpers/config'
// import FormFarmer from "@/components/Profile/FormFarmer";
import FormRetailer from '@/components/Profile/FormRetailer'
import { EventBus } from '@/helpers/event-bus'
export default {
  name: 'ProfileSidebar',
  components: {
    // FormFarmer,
    FormRetailer
  },

  data () {
    return {
      features: Config.features,
      role: Config.role,
      show_key_form: '',
      user: null,
      pass_data: null,
      url: null,
      registering_farmer: false
    }
  },
  methods: {
    modalData (obj) {
      this.$alertify.success(this.$t('Updated info successfully'))
      // this.$emit("refreshProfile");
      this.refreshProfile()
    },
    registerFarmer () {
      this.registering_farmer = true
      // return;
      let request
      // console.log("data", data);

      // request = Utils.request(this, true, "farm").post(`/update/`, data);
      request = Utils.request(this, true, 'farm').post(`/update/`, {
        description: 'Something here'
      })

      request.then((response) => {
        this.refreshProfile()
        this.registering_farmer = false
      })
    },
    showModal (data) {
      // if (!this.user.phone){
      //   return Utils.showError(this, this.$t("You need update phone before use this function"))
      // }

      let key
      this.pass_data = data != null ? JSON.parse(JSON.stringify(data)) : data
      this.show_key_form = 'formRetailer'
      // if (is_farmer) {
      //   this.show_key_form = "formFarmer";
      // } else {
      //   this.show_key_form = "formRetailer";
      // }

      setTimeout(() => {
        this.$refs[this.show_key_form].open()
      })
    },
    refreshProfile () {
      let wating = [Utils.request(this).get(`/getMyProfile/`)]

      Promise.all(wating).then((values) => {
        this.user = values[0].data.data
        this.$localStorage.set('user', JSON.stringify(this.user))
        EventBus.$emit('updateUser', this.user)
      })
    },
    refreshHandler (data) {
      if (data) {
        this.user = data
      }
    }
  },
  mounted () {
    EventBus.$on('updateUser', this.refreshHandler)
    this.user = Utils.getUser(this)
    this.url = location.pathname
  },
  beforeDestroy () {
    EventBus.$off('updateUser', this.refreshHandler)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Profile/ProfileSidebar.vue